import moment from 'moment';

const enableTaxReminder = (): boolean => {
  const currentDate = moment();
  const currentYear = currentDate.format('YYYY');

  const taxReminderStart = `${currentYear}-06-03T00:00:00`;
  const taxReminderEnd = `${currentYear}-06-30T23:59:59`;

  return currentDate.isBetween(taxReminderStart, taxReminderEnd, undefined, '[]');
};

export default enableTaxReminder;
